
import React from "react";
import "./buttonHL.css";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Standard button component in the a3 framework
 */
const ButtonHLPure = (props) => {
  const {
    nameBtn, //Text in btn
    primary, //Btn true to primary colors
    onClickBtn, //Function onClick button
    disabled, //True to disabled button, false not disabled
    outlined, // True or false to add a border
    colorScheme, // "primary" | "secondary" | "neutral" | "success" | "error" | "warning" | "info" | "text"
  } = props;

  return (
    <button
      type="button"
      className={`buttonHLPure ${primary ? "buttonHLPure-primary" : colorScheme ? `buttonHLPure-${colorScheme}` : "buttonHLPure-secondary"} ${outlined ? "outlined" : ""}`}
      disabled={disabled}
      onClick={onClickBtn ? onClickBtn : props.onClick}
      {...props}
    >
      {nameBtn}
    </button>
  );
};

export { ButtonHLPure as default };